import { DateTime } from "luxon";

export function getDateValueType(maxDate: string, bookingTo: string | null): boolean {
  const dt = DateTime.fromISO(maxDate);
  if (!dt.isValid) return false;

  // Otherwise → full ISO datetime (with optional timezone)
  // Rule: if bookingTo matches the date part, return time
  const maxDateDay = dt.toISODate(); // 'YYYY-MM-DD'

  // When maxDate has a time set (from weekday+time or time-only advanced booking), use it as valid end
  if (bookingTo && bookingTo === maxDateDay) {
    const isMaxTimeSet = dt.toFormat("HH:mm") === "00:00";
    if (isMaxTimeSet) return false;
    return true;
  }

  return false;
}
